import { Section } from "@/components/section";
import { Card, CardContent } from "@/components/ui/card";
import { triggerHaptic } from "@/lib/haptic-feedback";
import type { Data } from "@/types/data";
import { HeartHandshake } from "lucide-react";

interface AgreementsSectionProps {
	data: Data;
}

export default function AgreementsSection({ data }: AgreementsSectionProps) {
	const activeAgreements = data["area-convenios"].convenios.filter(
		(convenio) => convenio.ativo,
	);

	return (
		<Section id="convenios" className="bg-zinc-100">
			<div className="mb-10 text-center md:mb-12">
				<div className="mb-4 flex justify-center">
					<div className="rounded-full border border-brand-100 bg-brand-50 p-3">
						<HeartHandshake className="h-10 w-10 text-brand-secondary-500" />
					</div>
				</div>
				<h2 className="text-3xl font-bold text-brand-700 md:text-4xl">
					{data["area-convenios"].titulo}
				</h2>
				<p className="mx-auto mt-4 max-w-2xl text-zinc-600">
					{data["area-convenios"].texto}
				</p>
			</div>

			<div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
				{activeAgreements.map((agreement, index) => {
					const cardContent = (
						<Card className="h-full rounded-xl border-zinc-200 bg-white py-0 transition-all duration-200 ease-out hover:-translate-y-0.5 hover:border-zinc-300 hover:shadow-md">
							<CardContent className="flex h-full flex-col items-center justify-center p-4 text-center md:p-5">
								<div className="mb-3 flex h-24 w-full items-center justify-center rounded-lg border border-zinc-100 bg-zinc-50 px-2 md:h-28">
									<img
										src={`/convenios/${agreement.imagem}`}
										alt={agreement.nome}
										className="h-full w-full object-contain p-1 md:p-2"
										loading="lazy"
									/>
								</div>
								<h3 className="text-sm leading-tight font-semibold text-zinc-800">
									{agreement.nome}
								</h3>
							</CardContent>
						</Card>
					);

					if (agreement.url) {
						return (
							<a
								key={`${agreement.nome}-${index}`}
								href={agreement.url}
								target="_blank"
								rel="noopener noreferrer"
								onClick={() => triggerHaptic("light")}
								className="block"
							>
								{cardContent}
							</a>
						);
					}

					return <div key={`${agreement.nome}-${index}`}>{cardContent}</div>;
				})}
			</div>
		</Section>
	);
}
